import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/useAuthStore'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/login'
    },

    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('@/views/Laporan/Dashboard.vue'),
      meta: { requiresAuth: true }
    },

    {
      path: '/laporan/dashboard',
      redirect: { name: 'Dashboard' },
    },


    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Auth/Login.vue'),
      meta: {
        hideInSidebar: true,
        fullpage: true,
        guest: true,
        noWrapperClass: true
      }
    },

    //ROUTE KONFIGURASI APLIKASI 
    {
      path: '/profile',
      name: 'Profile',
      component: () => import('@/views/konf-aplikasi/Profile.vue'),
      meta: { hideInSidebar: true }
    },
    {
      path: '/change-password',
      name: 'Ubah Password',
      component: () => import('@/views/konf-aplikasi/UbahPassword.vue'),
      meta: { hideInSidebar: true }
    },
    // Menu dengan Dropdown
    {
      path: "/conf-aplikasi",
      name: "Konfigurasi Aplikasi",
      // component: null, 
      children: [
        { path: "pengguna", name: "Pengguna", component: () => import('@/views/konf-aplikasi/Pengguna.vue') },
        { path: "role", name: "Roles", component: () => import('@/views/konf-aplikasi/Role.vue') },
        {
          path: "/conf-aplikasi/role/tambah",
          name: "Tambah Role",
          component: () => import('@/views/konf-aplikasi/TambahRole.vue'),
          meta: { hideInSidebar: true }
        },
        {
          path: "/conf-aplikasi/role/edit/:id",
          name: "Edit Role",
          component: () => import('@/views/konf-aplikasi/EditRole.vue'),
          meta: { hideInSidebar: true }
        }
      ],
    },



    //ROUTE DATA REFERENSI
    {
      path: "/data-ref",
      name: "Data Referensi",
      // component: null, 
      children: [
        {
          path: "kota-kab", name: "Kota/Kabupaten", component: () => import('@/views/data-ref/KabupatenKota.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "kecamatan", name: "Kecamatan", component: () => import('@/views/data-ref/Kecamatan.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "kelurahan", name: "Kelurahan", component: () => import('@/views/data-ref/Kelurahan.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "bidang", name: "Bidang", component: () => import('@/views/data-ref/Bidang.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "jenis-usaha", name: "Jenis Usaha", component: () => import('@/views/data-ref/JenisUsaha.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "jenis-sumur", name: "Jenis Sumur", component: () => import('@/views/data-ref/JenisSumur.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "golongan-tarif", name: "Golongan Tarif", component: () => import('@/views/data-ref/GolonganTarif.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "jangkauan", name: "Jangkauan", component: () => import('@/views/data-ref/Jangkauan.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "gedung", name: "Gedung", component: () => import('@/views/data-ref/Gedung.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "dokumen", name: "Dokumen Referensi", component: () => import('@/views/data-ref/DokReferensi.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "kelompok-usaha", name: "Kelompok Usaha", component: () => import('@/views/data-ref/KelUsaha.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "kelompok-pengusahaan", name: "Kelompok Pengusahaan", component: () => import('@/views/data-ref/KelPengusahaan.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },
        {
          path: "kualitas-air", name: "Kualitas Air", component: () => import('@/views/data-ref/KualitasAir.vue'),
          //  meta: { requiresAuth: true, permission: 'get:api/users' } 
        },

      ],
    },
    //ROUTE MASTER DATA
    {
      path: "/master-data/wilayah",
      redirect: "/master-data/wilayah/index",
      name: "Master Data",
      children: [
        {
          path: "index",
          name: "Wilayah",
          component: () => import('@/views/master-data/WilayahLayout.vue'),
        },
        {
          path: "kota-kab",
          name: "Kota/Kabupaten",
          component: () => import('@/views/data-ref/KabupatenKota.vue'),
        },
        {
          path: "kecamatan",
          name: "Kecamatan",
          component: () => import('@/views/master-data/Kecamatan.vue'),
        },
        {
          path: "kelurahan",
          name: "Kelurahan",
          component: () => import('@/views/master-data/Kelurahan.vue'),
        }
      ]
    },

    //PENGOLAHAN DATA
    {
      path: "/pengolahan-data",
      name: "Pengolahan Data",
      // component: null, 
      children: [
        {
          path: "pelanggan", name: "Pelanggan", component: () => import('@/views/Pengolahan-data/Pelanggan.vue')
        },
        {
          path: "pemakaian-air-bulanan",
          name: "Pemakaian Air Tanah Bulanan",
          component: () => import('@/views/Pengolahan-data/PemakaianAirBulanan.vue'),
          meta: { requiresAuth: true, permission: 'get:api/pelanggan' }

        },
        {
          path: "novak-reg", name: "Novak Reg", component: () => import('@/views/Pengolahan-data/NovakReg.vue'),
          meta: { requiresAuth: true, permission: 'get:api/novakreg' }
        },
        {
          path: "permohonan-baru", name: "Permohonan Baru", component: () => import('@/views/Pengolahan-data/PermohonanBaru.vue'),
          meta: { requiresAuth: true, permission: 'get:api/permohonan-baru' }
        },
        {
          path: "identifikasi-sumur", name: "Identifikasi Sumur Ilegal", component: () => import('@/views/Pengolahan-data/IdentifikasiSumurIlegal.vue'),
          meta: { requiresAuth: true, permission: 'get:api/identifikasi-sumur-ilegal' }
        }
      ]
    },
    //zobat
    {
      path: "/zona-bebas-air",
      name: "Zobat",
      // component: null, 
      children: [
        {
          path: "zobat", name: "zobat", component: () => import('@/views/Zona-Bebas-Air/Zobat.vue')
        },
      ]
    },


    //MODUL LAPORAN
    {
      path: "/laporan",
      name: "Laporan",
      children: [

        {
          path: "rekap-pelanggan",
          name: "Rekap Pelanggan",
          component: () => import('@/views/Laporan/RekapPelanggan.vue')
        },
        {
          path: "rekap-bulanan",
          name: "Rekap Pemakaian Bulanan",
          component: () => import('@/views/Laporan/RekapPemakaiBulanan.vue')
        },
        {
          path: "rekap-npa",
          name: "Rekap NPA",
          component: () => import('@/views/Laporan/RekapNpa.vue')
        },
        {
          path: "rekap-cater",
          name: "Rekap Cater",
          component: () => import('@/views/Laporan/RekapCater.vue')
        },
        {
          path: "rekap-jenis-sumur",
          name: "Rekap Jenis Sumur",
          component: () => import('@/views/Laporan/RekapJenisSumur.vue')
        },
        {
          path: "rekap-status-sumur",
          name: "Rekap Status Sumur",
          component: () => import('@/views/Laporan/RekapStatusSumur.vue')
        },
        {
          path: "rekap-kualitas-air",
          name: "Rekap Kualitas Air",
          component: () => import('@/views/Laporan/RekapKualitasAir.vue')
        },
      ]
    },

    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/errors/NotFound.vue'),

    },

  ],
})


// router.beforeEach(async (to, from, next) => {
//   const auth = useAuthStore()
//   console.log('[router] guard checking auth:', {
//     isLoggedIn: auth.isLoggedIn,
//     hasToken: !!auth.token,
//     hasUser: !!auth.user?.id,
//     path: to.path
//   })


//   // Jika ke login page dan sudah login, redirect ke dashboard
//   if (to.name === 'Login' && auth.isLoggedIn) {
//     return next({ name: 'Dashboard' })
//   }

//   // Jika route butuh auth dan belum login, redirect ke login
//   if (to.meta.requiresAuth && !auth.isLoggedIn) {
//     return next({ 
//       name: 'Login',
//       query: { redirect: to.fullPath }
//     })
//   }

//   next()

//     const onChangePage = to.name === 'UbahPassword';
//   if (auth.forceChangePassword && !onChangePage) {
//     return {name: 'Ubah Password', query: { returnTo: to.fullPath }}
//   } 
//   return true;  
// })

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore()
  console.log('[router] guard checking auth:', {
    isLoggedIn: auth.isLoggedIn,
    hasToken: !!auth.token,
    hasUser: !!auth.user?.id,
    path: to.path
  })

  const isLoginPage = to.name === 'Login'
  const isChangePage = to.name === 'Ubah Password' || to.path === '/change-password'
  const isLogoutPage = to.name === 'Logout' || to.path === '/logout'
  const isForgotPage = to.name === 'ForgotPassword' || to.path === '/forgot-password'
  const whitelistedWhileForced = isChangePage || isLoginPage || isLogoutPage || isForgotPage || to.name === 'NotFound'

  // Jika sudah login, jangan izinkan ke Login lagi
  if (isLoginPage && auth.isLoggedIn) return next({ name: 'Dashboard' })

  // Jika user wajib mengganti password dan sudah terautentikasi, arahkan ke halaman ubah password
  if (auth.forceChangePassword && auth.isLoggedIn && !whitelistedWhileForced) {
    return next({ name: 'Ubah Password', query: { returnTo: to.fullPath } })
  }

  // Jika route butuh auth dan belum login, redirect ke login
  if (to.meta.requiresAuth && !auth.isLoggedIn) {
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  }

  return next()
})

export default router